import React from "react";
import { Routes, Route, Link, useLocation, Navigate, useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";
import { Play, Layers, Users, Copy, GitBranch } from "lucide-react";
import Accounts from "./pages/Accounts";
import Groups from "./pages/Groups"; 
import { AccountsProvider } from "./context/AccountsContext";
import { useAccounts } from "./context/AccountsContext"; // ✅ ADDED
import SecretEntry from "./pages/SecretEntry";
import AdminLogin from "./pages/AdminLogin";
import AdminPanel from "./pages/AdminPanel";
import Home from "./pages/Home";
import Orders from "./pages/Orders";
import Positions from "./pages/Positions";
import BloombergWatch from "./pages/BloombergWatch";
import CopyTrading from "./pages/CopyTrading";
import TwoFactorSetup from "./pages/TwoFactorSetup";
import TwoFactorVerify from "./pages/TwoFactorVerify";
import AdminDashboard from "./pages/adminDashboard";
import EmailOtpVerify from "./pages/EmailOtpVerify";
import BankNifty from "./pages/BankNifty";
import Bankex from "./pages/Bankex";
import Jammu from "./pages/Jammu";
import Nexo from "./pages/Nexo";
import NexoAssistant from "./pages/NexoAssistant";
import NiftySupportPage from "./pages/NiftySupportPage";
import MobileAppNav from "./components/MobileAppNav";
import "./styles/mobile-app.css";
import "./styles/gold-terminal.css";
import BloombergTerminal from "./pages/bloombergterminal";
import GlobalBloombergAlertCenter from "./components/GlobalBloombergAlertCenter";
import GlobalBloombergManualSupportFetcher from "./components/GlobalBloombergManualSupportFetcher";
import OptionDecayDesk from "./pages/OptionDecayDesk";
import SecretExpiryDesk from "./pages/SecretExpiryDesk";
import GlobalOptionDecayFetcher from "./components/GlobalOptionDecayFetcher";
import MarketReactionGrid from "./pages/MarketReactionGrid";
import StrikeMarketReactionGrid from "./pages/StrikeMarketReactionGrid";
import Stocks from "./pages/Stocks";
import BnStocks from "./pages/bnstocks";
import SnStocks from "./pages/snstocks";
import Indicators from "./pages/Indicators";
import GlobalAudioPlayer from "./components/GlobalAudioPlayer";
import NexoAssistantAgent from "./components/NexoAssistantAgent";
import ScannerLogin from "./pages/ScannerLogin";
import MobileQrScanner from "./pages/MobileQrScanner";
import FaceLogin from "./pages/FaceLogin";
import WorldMonitorClone from "./pages/WorldMonitorClone";
import DhanStocks from "./pages/dhanstocks";
import BnDhanStocks from "./pages/bndhanstocks";
import SnDhanStocks from "./pages/sndhanstocks";
import DhanBigMoneyFlow from "./pages/dhanbigmoneyflow";
import RetentionDays from "./pages/retentiondays";
import WhatsAppAlerts from "./pages/WhatsAppAlerts";



/* Dashboard Component (your existing UI) */
function Dashboard() {
  return (
    <div className="p-6">

      {/* Engine Card */}
      <div className="bg-[#1e293b] p-6 rounded-xl flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-semibold">Copy Trading Engine</h2>
          <p className="mt-2">
            Status: <span className="text-red-500">Stopped</span>
          </p>
        </div>

        <button className="flex items-center gap-2 bg-green-500 px-5 py-3 rounded-lg">
          <Play size={18} /> Start Copy Trading
        </button>
      </div>

      {/* Cards */}
      <div className="grid md:grid-cols-4 gap-6">

        <div className="bg-[#1e293b] p-5 rounded-xl flex justify-between items-center">
          <div>
            <p className="text-gray-400">Copy Groups</p>
            <h2 className="text-3xl font-bold">1</h2>
            <p className="text-green-400">1 Active</p>
          </div>
          <div className="bg-blue-500 p-3 rounded-full">
            <Layers />
          </div>
        </div>

        <div className="bg-[#1e293b] p-5 rounded-xl flex justify-between items-center">
          <div>
            <p className="text-gray-400">Total Accounts</p>
            <h2 className="text-3xl font-bold">2</h2>
            <p className="text-green-400">2 Connected</p>
          </div>
          <div className="bg-green-500 p-3 rounded-full">
            <Users />
          </div>
        </div>

        <div className="bg-[#1e293b] p-5 rounded-xl flex justify-between items-center">
          <div>
            <p className="text-gray-400">Today's Copies</p>
            <h2 className="text-3xl font-bold">0</h2>
            <p className="text-green-400">Success Rate: 0.0%</p>
          </div>
          <div className="bg-purple-500 p-3 rounded-full">
            <Copy />
          </div>
        </div>

        <div className="bg-[#1e293b] p-5 rounded-xl flex justify-between items-center">
          <div>
            <p className="text-gray-400">Parent/Child</p>
            <h2 className="text-3xl font-bold">1/1</h2>
          </div>
          <div className="bg-orange-500 p-3 rounded-full">
            <GitBranch />
          </div>
        </div>

      </div>
    </div>
  );
}

//Login Addition

const LOGIN_TOKEN_KEY = "ct_login_token";
const LOGIN_USER_KEY = "ct_login_user";
const PUBLIC_PATHS = [
  "/login",
  "/mobile-scanner",
  "/scan-approve",
  "/two-factor-setup",
  "/two-factor",
  "/email-otp",
];

function getLoginUser() {
  try {
    return JSON.parse(localStorage.getItem(LOGIN_USER_KEY) || "null");
  } catch {
    return null;
  }
}

function defaultRouteForRole(role) {
  if (role === "nexo") return "/nexo";
  if (role === "secret") return "/x-portal";
  return "/";
}

function clearLoginState() {
  localStorage.removeItem("ct_login_token");
  localStorage.removeItem("ct_login_user");
  localStorage.removeItem("ct_admin_auth");
  localStorage.removeItem("ct_2fa_token");
  localStorage.removeItem("ct_2fa_user");
  localStorage.removeItem("ct_email_otp_token");
}


function RequireAuth({ children, adminOnly = false, allowedRoles = null }) {
  const location = useLocation();
  const token = localStorage.getItem(LOGIN_TOKEN_KEY);
  const user = getLoginUser();

  if (!token || !user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (adminOnly && user.role !== "admin") {
  return <Navigate to={defaultRouteForRole(user.role)} replace />;
}

const allowedByBackend = canOpenPage(user, location.pathname);

if (allowedRoles && !allowedRoles.includes(user.role) && !allowedByBackend) {
  return <Navigate to={defaultRouteForRole(user.role)} replace />;
}

if (!adminOnly && !allowedByBackend) {
  return <Navigate to={defaultRouteForRole(user.role)} replace />;
}

  return children;
}

const API_BASE = window.location.hostname === "localhost" ? "http://localhost:5000" : "";

function canOpenPage(user, path) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (!Array.isArray(user.pageAccess)) return false;
  return user.pageAccess.includes(path);
}

function AppContent() {
  const location = useLocation();
  const { accounts } = useAccounts(); // ✅ ADDED
  const clickRef = useRef(0); // ✅ ADD THIS
  const currentUser = getLoginUser();
  const isAdmin = currentUser?.role === "admin";
  const isPublicPath = PUBLIC_PATHS.includes(location.pathname);
  const navigate = useNavigate();

    useEffect(() => {
    if (PUBLIC_PATHS.includes(location.pathname)) return;

    const checkActiveSession = async () => {
      const token = localStorage.getItem("ct_login_token");

      if (!token) return;

      try {
        const res = await fetch("/api/login/me", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.status === 401) {
          await new Promise(resolve => setTimeout(resolve, 1500));

          const retry = await fetch("/api/login/me", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          if (retry.status === 401) {
            clearLoginState();
            navigate("/login", { replace: true });
            return;
          }

          if (retry.ok) {
            const data = await retry.json().catch(() => ({}));
            if (data.success && data.user) {
              localStorage.setItem(LOGIN_USER_KEY, JSON.stringify(data.user));
            }
          }

          return;
        }

        if (res.ok) {
          const data = await res.json().catch(() => ({}));
          if (data.success && data.user) {
            localStorage.setItem(LOGIN_USER_KEY, JSON.stringify(data.user));
          }
        }

      } catch {
        // Keep user on page if server is temporarily unreachable.
      }
    };

    checkActiveSession();

    const timer = setInterval(checkActiveSession, 10000);

    return () => clearInterval(timer);
  }, [location.pathname, navigate]);

  const navLink = (path, name) => (
    <Link
      to={path}
      className={`px-4 py-2 rounded ${
        location.pathname === path
          ? "bg-blue-500"
          : "hover:text-blue-400"
      }`}
    >
      {name}
    </Link>
  );

  return (
    <div className="app-root-shell gold-terminal min-h-screen">

      {/* Navbar */}
      {!isPublicPath && (
      <div className="desktop-navbar flex items-center justify-between px-6 py-4 bg-[#1e293b] shadow">

        {/* Logo */}
        <div
          className="flex items-center gap-3 cursor-pointer"
          onClick={() => navigate(defaultRouteForRole(currentUser?.role))}
        >
          <img
          src="/logo.png.jpg"
          alt="Nexovate Groups"
          className="w-10 h-10 object-contain"
        />
          <h1
            className="text-lg font-bold tracking-wide leading-[1.05]"
            style={{
              color: "#86efac",
              textShadow: "0 0 8px rgba(134,239,172,0.95), 0 0 18px rgba(34,197,94,0.8), 0 0 34px rgba(22,163,74,0.6)",
            }}
          >
            <span className="block">Nexovate</span>
            <span className="block">Groups</span>
            <span className="block">Inc</span>
          </h1>
        </div>

        {/* Menu */}
        <div className="flex items-center gap-4">
          {canOpenPage(currentUser, "/") && navLink("/", "Dashboard")}
          {isAdmin && navLink("/admin-dashboard", "AdminDashboard")}
          {["/x-portal", "/nifty-support", "/dhan-big-money-flow", "/dhan-stocks"].some(path =>
            canOpenPage(currentUser, path)
          ) && (
            <div className="relative group">
              <Link
                to="/x-portal"
                className={`px-4 py-2 rounded inline-block ${
                  ["/x-portal", "/nifty-support", "/dhan-big-money-flow", "/dhan-stocks"].includes(location.pathname)
                    ? "bg-blue-500"
                    : "hover:text-blue-400"
                }`}
              >
                Secret
              </Link>

              <div className="absolute left-0 top-full hidden group-hover:block z-50 min-w-[180px] rounded-lg border border-slate-700 bg-[#0f172a] shadow-xl overflow-hidden">
                {canOpenPage(currentUser, "/x-portal") && (
                  <Link
                    to="/x-portal"
                    className={`block px-4 py-2 text-sm ${
                      location.pathname === "/x-portal"
                        ? "bg-blue-500"
                        : "hover:bg-[#1e293b] hover:text-blue-300"
                    }`}
                  >
                    Secret Page
                  </Link>
                )}

                {canOpenPage(currentUser, "/nifty-support") && (
                  <Link
                    to="/nifty-support"
                    className={`block px-4 py-2 text-sm ${
                      location.pathname === "/nifty-support"
                        ? "bg-blue-500"
                        : "hover:bg-[#1e293b] hover:text-blue-300"
                    }`}
                  >
                    Support Scanner
                  </Link>
                )}
                
                {canOpenPage(currentUser, "/dhan-big-money-flow") && (
                  <Link
                    to="/dhan-big-money-flow"
                    className={`block px-4 py-2 text-sm ${
                      location.pathname === "/dhan-big-money-flow"
                        ? "bg-blue-500"
                        : "hover:bg-[#1e293b] hover:text-blue-300"
                    }`}
                  >
                    Dhan Big Money Flow
                  </Link>
                )}

                {canOpenPage(currentUser, "/dhan-stocks") && (
                  <Link
                    to="/dhan-stocks"
                    className={`block px-4 py-2 text-sm ${
                      location.pathname === "/dhan-stocks"
                        ? "bg-blue-500"
                        : "hover:bg-[#1e293b] hover:text-blue-300"
                    }`}
                  >
                    Dhan Stocks
                  </Link>
                )}
              </div>
            </div>
          )}
          {canOpenPage(currentUser, "/accounts") && navLink("/accounts", "Accounts")}
          {canOpenPage(currentUser, "/groups") && navLink("/groups", "Groups")}
          {canOpenPage(currentUser, "/orders") && navLink("/orders", "Orders")}
          {canOpenPage(currentUser, "/Positions") && navLink("/Positions", "Positions")}
          {(isAdmin || [
            "/nexo",
            "/nexo-assistant",
            "/bloomberg-watch",
            "/expiry-decay-desk",
            "/bloomberg-terminal",
            "/option-decay",
            "/market-reaction",
            "/strike-market-reaction",
            "/stocks",
            "/indicators",
            "/world-monitor",
          ].some(path => canOpenPage(currentUser, path))) && (
            <div className="relative group">
              <Link
                to="/nexo"
                className={`px-4 py-2 rounded inline-block ${
                  [
                    "/nexo",
                    "/whatsapp-alerts",
                    "/nexo-assistant",
                    "/bloomberg-watch",
                    "/option-decay",
                    "/expiry-decay-desk",
                    "/bloomberg-terminal",
                    "/market-reaction",
                    "/strike-market-reaction",
                    "/stocks",
                    "/indicators",
                    "/world-monitor",
                  ].includes(location.pathname)
                    ? "bg-blue-500"
                    : "hover:text-blue-400"
                }`}
              >
                Nexo
              </Link>

              {(isAdmin || [
                "/nexo-assistant",
                "/bloomberg-watch",
                "/expiry-decay-desk",
                "/bloomberg-terminal",
                "/market-reaction",
                "/strike-market-reaction",
                "/stocks",
                "/indicators",
                "/world-monitor",
              ].some(path => canOpenPage(currentUser, path))) && (
                <div className="absolute right-0 top-full hidden group-hover:block z-50 min-w-[190px] rounded-lg border border-slate-700 bg-[#0f172a] shadow-xl overflow-hidden">

                  {isAdmin && (
                    <Link
                      to="/whatsapp-alerts"
                      className={`block px-4 py-2 text-sm ${
                        location.pathname === "/whatsapp-alerts"
                          ? "bg-blue-500"
                          : "hover:bg-[#1e293b] hover:text-blue-300"
                      }`}
                    >
                      WhatsApp Alerts
                    </Link>
                  )}

                  {canOpenPage(currentUser, "/bloomberg-watch") && (
                    <Link
                      to="/bloomberg-watch"
                      className={`block px-4 py-2 text-sm ${
                        location.pathname === "/bloomberg-watch"
                          ? "bg-blue-500"
                          : "hover:bg-[#1e293b] hover:text-blue-300"
                      }`}
                    >
                      BloombergWatch
                    </Link>
                  )}

                  {canOpenPage(currentUser, "/nexo-assistant") && (
                    <Link
                      to="/nexo-assistant"
                      className={`block px-4 py-2 text-sm ${
                        location.pathname === "/nexo-assistant"
                          ? "bg-blue-500"
                          : "hover:bg-[#1e293b] hover:text-blue-300"
                      }`}
                    >
                      Nexo Assistant
                    </Link>
                  )}

                  {canOpenPage(currentUser, "/expiry-decay-desk") && (
                    <Link
                      to="/expiry-decay-desk"
                      className={`block px-4 py-2 text-sm ${
                        location.pathname === "/expiry-decay-desk"
                          ? "bg-blue-500"
                          : "hover:bg-[#1e293b] hover:text-blue-300"
                      }`}
                    >
                      Expiry Decay Desk
                    </Link>
                  )}

                  {canOpenPage(currentUser, "/bloomberg-terminal") && (
                    <Link
                      to="/bloomberg-terminal"
                      className={`block px-4 py-2 text-sm ${
                        location.pathname === "/bloomberg-terminal"
                          ? "bg-blue-500"
                          : "hover:bg-[#1e293b] hover:text-blue-300"
                      }`}
                    >
                      Bloomberg Terminal
                    </Link>
                  )}

                  {canOpenPage(currentUser, "/market-reaction") && (
                    <Link
                      to="/market-reaction"
                      className={`block px-4 py-2 text-sm ${
                        location.pathname === "/market-reaction"
                          ? "bg-blue-500"
                          : "hover:bg-[#1e293b] hover:text-blue-300"
                      }`}
                    >
                      Market Reaction
                    </Link>
                  )}

                  {canOpenPage(currentUser, "/stocks") && (
                    <Link
                      to="/stocks"
                      className={`block px-4 py-2 text-sm ${
                        location.pathname === "/stocks"
                          ? "bg-blue-500"
                          : "hover:bg-[#1e293b] hover:text-blue-300"
                      }`}
                    >
                      Stocks
                    </Link>
                  )}

                  {canOpenPage(currentUser, "/indicators") && (
                    <Link
                      to="/indicators"
                      className={`block px-4 py-2 text-sm ${
                        location.pathname === "/indicators"
                          ? "bg-blue-500"
                          : "hover:bg-[#1e293b] hover:text-blue-300"
                      }`}
                    >
                      Indicators
                    </Link>
                  )}

                  {canOpenPage(currentUser, "/world-monitor") && (
                    <Link
                      to="/world-monitor"
                      className={`block px-4 py-2 text-sm ${
                        location.pathname === "/world-monitor"
                          ? "bg-blue-500"
                          : "hover:bg-[#1e293b] hover:text-blue-300"
                      }`}
                    >
                      World Monitor
                    </Link>
                  )}

                </div>
              )}
            </div>
          )}
        </div>

        {/* Right */}
        <div className="flex items-center gap-4">
          <button
            onClick={async () => {
              const token = localStorage.getItem("ct_login_token");

              if (token) {
                await fetch("/api/login/logout", {
                  method: "POST",
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }).catch(() => {});
              }

              localStorage.removeItem("ct_login_token");
              localStorage.removeItem("ct_login_user");
              localStorage.removeItem("ct_admin_auth");
              navigate("/login", { replace: true });
            }}
            className="bg-red-500 px-4 py-2 rounded"
          >
            Logout
          </button>

        </div>

      </div>
      )}

      {/* Routes */}
      {!isPublicPath && (
      <>
      <GlobalBloombergAlertCenter />
      <GlobalBloombergManualSupportFetcher />
      </>
      )}
      <Routes>

        <Route path="/login" element={<FaceLogin />} />
        <Route path="/credentials-login" element={<ScannerLogin />} />
        <Route path="/mobile-scanner" element={<MobileQrScanner />} />
        <Route path="/scan-approve" element={<MobileQrScanner />} />
        <Route path="/two-factor-setup" element={<TwoFactorSetup />} />
        <Route path="/two-factor" element={<TwoFactorVerify />} />
        <Route path="/email-otp" element={<EmailOtpVerify />} />
        <Route path="/" element={<RequireAuth allowedRoles={["admin", "user"]}><Home /></RequireAuth>} />
        <Route path="/accounts" element={<RequireAuth allowedRoles={["admin", "user"]}><Accounts /></RequireAuth>} />
        <Route path="/groups" element={<RequireAuth allowedRoles={["admin", "user"]}><Groups accounts={accounts} /></RequireAuth>} />
        <Route path="/nifty-support" element={<RequireAuth allowedRoles={["admin", "user", "secret"]}><NiftySupportPage /></RequireAuth>} />
        <Route path="/bloomberg-terminal" element={<RequireAuth allowedRoles={["admin", "user", "nexo", "secret"]}><BloombergTerminal /></RequireAuth>} />
        <Route
          path="/option-decay"
          element={
            <RequireAuth allowedRoles={["admin", "user", "nexo", "secret"]}>
              <OptionDecayDesk />
            </RequireAuth>
          }
        />
        <Route
          path="/expiry-decay-desk"
          element={
            <RequireAuth allowedRoles={["admin", "user", "nexo", "secret"]}>
              <SecretExpiryDesk />
            </RequireAuth>
          }
        />
        <Route
          path="/market-reaction"
          element={
            <RequireAuth allowedRoles={["admin", "user", "nexo", "secret"]}>
              <MarketReactionGrid />
            </RequireAuth>
          }
        />
        <Route
          path="/strike-market-reaction"
          element={
            <RequireAuth allowedRoles={["admin", "user", "nexo", "secret"]}>
              <StrikeMarketReactionGrid />
            </RequireAuth>
          }
        />
        <Route
          path="/stocks"
          element={
            <RequireAuth allowedRoles={["admin", "user", "nexo", "secret"]}>
              <Stocks />
            </RequireAuth>
          }
        />
        <Route path="/bnstocks" element={<RequireAuth allowedRoles={["admin", "user", "nexo", "secret"]}><BnStocks /></RequireAuth>} />
        <Route path="/snstocks" element={<RequireAuth allowedRoles={["admin", "user", "nexo", "secret"]}><SnStocks /></RequireAuth>} />
        <Route
          path="/indicators"
          element={
            <RequireAuth allowedRoles={["admin", "user", "nexo", "secret"]}>
              <Indicators />
            </RequireAuth>
          }
        />
        <Route
          path="/world-monitor"
          element={
            <RequireAuth allowedRoles={["admin", "user", "nexo", "secret"]}>
              <WorldMonitorClone />
            </RequireAuth>
          }
        />
        <Route
          path="/dhan-stocks"
          element={
            <RequireAuth allowedRoles={["admin", "user", "secret"]}>
              <DhanStocks />
            </RequireAuth>
          }
        />
        <Route path="/dhan-big-money-flow" element={<RequireAuth allowedRoles={["admin", "user", "secret"]}><DhanBigMoneyFlow /></RequireAuth>} />
        <Route path="/bndhanstocks" element={<RequireAuth allowedRoles={["admin", "user", "secret"]}><BnDhanStocks /></RequireAuth>} />
        <Route path="/sndhanstocks" element={<RequireAuth allowedRoles={["admin", "user", "secret"]}><SnDhanStocks /></RequireAuth>} />

        {/* SECRET ROUTES (ADDED) */}

        <Route path="/orders" element={<RequireAuth allowedRoles={["admin", "user"]}><Orders /></RequireAuth>} />
        <Route path="/Positions" element={<RequireAuth allowedRoles={["admin", "user"]}><Positions /></RequireAuth>} />
        <Route path="/bloomberg-watch" element={<RequireAuth allowedRoles={["admin", "user", "nexo", "secret"]}><BloombergWatch /></RequireAuth>} />
        <Route path="/copy-trading" element={<RequireAuth allowedRoles={["admin", "user"]}><CopyTrading /></RequireAuth>} />
        <Route path="/nexo" element={<RequireAuth allowedRoles={["admin", "user", "nexo", "secret"]}><Nexo /></RequireAuth>} />
        <Route path="/nexo-assistant" element={<RequireAuth allowedRoles={["admin", "user", "nexo", "secret"]}><NexoAssistant /></RequireAuth>} />


{/* SECRET ROUTES (ADDED) Admin Login Only */}
<Route path="/x-portal" element={<RequireAuth allowedRoles={["admin", "user", "secret"]}><SecretEntry /></RequireAuth>} />
<Route path="/x-login" element={<Navigate to="/login" replace />} />
<Route path="/x-admin" element={<RequireAuth allowedRoles={["admin", "user", "secret"]}><AdminPanel /></RequireAuth>} />
<Route path="/admin-dashboard" element={<RequireAuth adminOnly><AdminDashboard /></RequireAuth>} />
<Route path="/whatsapp-alerts" element={<RequireAuth adminOnly><WhatsAppAlerts /></RequireAuth>} />
<Route path="/banknifty" element={<RequireAuth allowedRoles={["admin", "user", "secret"]}><BankNifty /></RequireAuth>} />
<Route path="/bankex" element={<RequireAuth allowedRoles={["admin", "user", "secret"]}><Bankex /></RequireAuth>} />
<Route path="/jammu" element={<RequireAuth allowedRoles={["admin", "user", "secret"]}><Jammu /></RequireAuth>} />
<Route
  path="/retention-days"
  element={
    <RequireAuth adminOnly>
      <RetentionDays />
    </RequireAuth>
  }
/>


        
            </Routes>
            {!isPublicPath && location.pathname === "/" && <GlobalAudioPlayer />}

      {!isPublicPath && <MobileAppNav />}
      {!isPublicPath && canOpenPage(currentUser, "/nexo-assistant") && <NexoAssistantAgent />}

    </div>
  );
}

/* ✅ WRAP WITH CONTEXT */
export default function App() {
  return (
    <AccountsProvider>
      <GlobalOptionDecayFetcher />
      <AppContent />
    </AccountsProvider>
  );
}
